<template lang="pug">
  v-content 
    v-container.mt-5(grid-list-md)
      v-layout(row, wrap)
        template(v-for="menu, i in menuItems")
          v-flex(xs12, sm6, md3)
            v-card 
              v-expansion-panel(expand, v-model="panel[i]")
                v-expansion-panel-content.accent
                  v-icon(slot="actions" color="white") arrow_drop_down
                  div(slot="header") 
                    h3.white--text {{menu.titulo}}
                  template(v-for="item in menu.items")
                    v-card
                      v-card-text.botonish(@click="irLink(item.ruta)")
                        v-layout(row, wrap)
                          v-flex(xs2)
                            v-icon.secondary--text {{item.icon}}
                          v-flex(xs10)
                            h3 {{item.text}}
</template>

<script>
import HelloWorld from '../../components/HelloWorld'
import Alertar from '../../components/Alertar'
export default {
  components: {
    HelloWorld,
    Alertar
  },
  data () {
    return {
      panel: [[true], [true], [true], [true]],
      ventas: [
        {icon: 'assignment', text: 'Cotizaciones', ruta: '/app/cotizaciones'},
        {icon: 'monetization_on', text: 'Ventas', ruta: '/app/ventas'},
        {icon: 'loyalty', text: 'Reservas', ruta: '/app/reservas'},
        {icon: 'timeline', text: 'Estadísticas', ruta: '/app/estadisticas'}
      ],
      existencias: [
        {icon: 'add_circle', text: 'Añadir Libro', ruta: '/app/anadir'},
        {icon: 'view_module', text: 'Catálogo', ruta: '/app/catalogo'},
        {icon: 'bookmark', text: 'Colecciones', ruta: '/app/colecciones'}      
      ],
      crm: [
        {icon: 'person', text: 'Clientes', ruta: '/app/clientes'},
        {icon: 'mail', text: 'Novedades', ruta: '/app/novedades'}
      ],
      otros: [
        {icon: 'web', text: 'Contenidos Web', ruta: '/app/contenidos'}
      ]
    }
  },
  mounted () {
    this.$store.commit('cat/modo', 'app')
    let indices = this.$store.getters['cat/indices']
    if (indices.length === 0)
      this.$store.dispatch('cat/armarIndices')
  },
  computed: {
    menuItems () {
      return [
        {titulo: 'Ventas', items: this.ventas},
        {titulo: 'Existencias', items: this.existencias},
        {titulo: 'CRM', items: this.crm},
        {titulo: 'Otros', items: this.otros}
      ]
    }
  },
  methods: {
    irLink (ruta) {
      if (ruta === '/app/catalogo')
        this.$store.commit('cat/deVenta', false)
      this.$router.push(ruta)
    }
  }
}
</script>